import '../../styles/ui/ui.scss'
const Button = ({type, text, color, ...buttonProps}) => (
    <button className={`btn-${type} button btn-${color}`} {...buttonProps}>
        {text}
    </button>
)
export default Button